import {atomWithReset} from 'jotai/utils'

export const storeWinnersDataState = atomWithReset<boolean>(false)
